import JourneyTicker from "./JourneyTicker";
import { TODAY_PAINS, AFTER_OUTCOMES } from "./constants";

export default function OwnerStory() {
  return (
    <section id="story" className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-red">The story we help you write</p>
          <h2 className="font-heading text-4xl md:text-5xl text-cvc-navy mt-4 leading-tight">
            From genius-with-helpers to an asset that runs without you.
          </h2>
          <p className="font-body text-cvc-ink-soft text-lg mt-6 leading-relaxed">
            Most local owners are wearing every hat — administration, sales, marketing, talent, leadership, finance.
            That's not a business; that's a glorified job. We come alongside you, week after week, and re-engineer your company
            one duty at a time until you can step out of the day-to-day for good.
          </p>
        </div>
        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-[1fr_auto_1fr] items-stretch gap-3 sm:gap-4">
            <div className="rounded-2xl bg-white border border-cvc-border p-7 shadow-sm">
              <p className="text-xs tracking-[0.25em] uppercase font-body font-semibold text-cvc-ink-soft">Today</p>
              <h3 className="font-heading text-3xl text-cvc-navy mt-2">Owner-operator</h3>
              <ul className="mt-4 space-y-2 font-body text-sm text-cvc-ink-soft">
                <li>· Genius-with-helpers / solopreneur</li>
                <li>· Wearing all 8 hats</li>
                <li>· Can't step away without things slipping</li>
                <li>· Income depends on owner's hours</li>
              </ul>
              <JourneyTicker items={TODAY_PAINS} tone="light" />
            </div>

            {/* Cartoon arrow Today → After — static, overlaps both card edges */}
            <div
              data-testid="journey-arrow"
              className="hidden sm:flex items-center justify-center relative z-10 -mx-5 lg:-mx-7"
              aria-hidden="true"
            >
              <svg
                width="110"
                height="74"
                viewBox="0 0 140 90"
                className="drop-shadow-[0_5px_8px_rgba(26,43,76,0.28)]"
                style={{ transform: "rotate(-4deg)" }}
              >
                <defs>
                  <linearGradient id="arrowFill" x1="0" x2="1" y1="0" y2="0">
                    <stop offset="0%" stopColor="#A83333" />
                    <stop offset="100%" stopColor="#741D1D" />
                  </linearGradient>
                </defs>
                {/* Chunky cartoon arrow body with cream outline + subtle highlight */}
                <path
                  d="M 8 52 C 32 30, 60 36, 88 42 L 88 24 L 134 49 L 88 72 L 88 58 C 60 50, 32 64, 8 62 Z"
                  fill="url(#arrowFill)"
                  stroke="#FAF7F2"
                  strokeWidth="4"
                  strokeLinejoin="round"
                />
                {/* Tiny inner highlight to enhance the cartoon-sticker feel */}
                <path
                  d="M 18 49 C 38 36, 58 41, 82 46"
                  stroke="rgba(250,247,242,0.45)"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  fill="none"
                />
              </svg>
            </div>

            <div className="rounded-2xl bg-cvc-navy text-cvc-cream p-7 shadow-md">
              <p className="text-xs tracking-[0.25em] uppercase font-body font-semibold text-cvc-cream/70">After scale-up</p>
              <h3 className="font-heading text-3xl mt-2">Turnkey asset</h3>
              <ul className="mt-4 space-y-2 font-body text-sm text-cvc-cream/90">
                <li>· Every duty delegated to the right seat</li>
                <li>· Frontline → middle mgmt → exec layer</li>
                <li>· Runs (and grows) without the owner</li>
                <li>· A real asset — saleable, financeable, durable</li>
              </ul>
              <JourneyTicker items={AFTER_OUTCOMES} tone="dark" />
            </div>
          </div>

          <p data-testid="journey-caption" className="mt-5 text-center font-heading italic text-xl md:text-2xl text-cvc-navy">
            Every great entrepreneurial story needs a great ending. We help you get your great ending.
          </p>
        </div>
      </div>
    </section>
  );
}
